export const handleTableId = (id) => id?.split('-')?.pop()

export const isEmptyFields = (field) => {
  return field?.length === 0
}

export const areFieldsNotEmpty = (fields) => {
  if (fields.some(field => field === undefined || field === null)) {
    return false
  }
  return fields?.length > 0 && fields.every(field => field?.length > 0)
}
